import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../services/validation.service';
import { PagerService } from '../../services/index';
import * as $ from 'jquery/dist/jquery.min.js';
declare var jQuery: any;

@Component({
	selector: 'app-profession-option',
	templateUrl: './profession-option.component.html',
	styleUrls: ['./profession-option.component.css']
})
export class ProfessionoptionComponent implements OnInit {
	professionForm: any;

	modalTitle: String = "Add profession";
	professionList: any = [];
	profession_language = "";
	profession_text = "";
	profession: any;
	edit_id = '';
	profession_edit_id = null;
	is_profession_edit = false;
	surveyCategoryList: any = [];
	languageList:any = [];

	constructor(
		private commonService: CommonService,
		private authService: AuthService,
		private router: Router,
		private validationService: ValidationService,
		private pagerService: PagerService,
		private activatedRoute: ActivatedRoute
	) { }

	ngOnInit() {
		$(".navbar-brand").text("Profession");

		this.professionForm = new FormGroup({
			profession: new FormControl("", Validators.compose([Validators.required])),
			category_id: new FormControl("", Validators.compose([Validators.required])),
			profession_language: new FormControl("", Validators.compose([null])),
			profession_name: new FormControl("", Validators.compose([null])),
		});

		this.activatedRoute.params.subscribe((params: any) => {
			this.edit_id = params.id;
			if (params.id) {
				this.getSingleprofession(this.edit_id);
			}
		});
		this.initialiseSurvey();

	}


	initialiseSurvey = function () {

		this.authService.getSurveyCategoryList().subscribe(data => {
			if (data.success) {
				this.surveyCategoryList = data.category;
			}
		});

		this.authService.getLanguageList().subscribe(data => {
			if (data.success) {
				this.languageList = data.language;
			}
		});

	}

	addProfession = function () {

		var profession_language = this.professionForm.controls['profession_language'].value;
		var profession_name = this.professionForm.controls['profession_name'].value;

		if (this.is_profession_edit) {

			this.professionList[this.profession_edit_id].profession_language = profession_language;
			this.professionList[this.profession_edit_id].profession_name = profession_name;

			this.professionForm.controls['profession_language'].setValue(null);
			this.professionForm.controls['profession_name'].setValue(null);

			this.is_profession_edit = false;
			this.profession_edit_id = null;

		} else {

			if (profession_language && profession_name) {

				if (!this.professionList.some((item) => item.profession_language == profession_language)) {
					this.professionList.push({
						'profession_language': profession_language,
						'profession_name': profession_name,
					});
				}
				this.professionForm.controls['profession_language'].setValue(null);
				this.professionForm.controls['profession_name'].setValue(null);
			}else{
				jQuery.growl.error({ title: 'Error', message: 'Please fill out all required fields' });
			}

		}

	}

	getSingleprofession = function (id) {

		this.authService.getSingleProfession(id).subscribe(data => {
			if (data.success) {
				this.professionList = data.result.profession_languages;
				this.professionForm.controls['profession'].setValue(data.result.profession);
				this.professionForm.controls['category_id'].setValue(data.result.category_id);
			} else {
				jQuery.growl.error({ title: 'Error', message: data.error });
			}

			this.authService.cancelProcess();
		});

	}

	deleteprofession = function (index) {
		this.professionList.splice(index, 1)
	}

	editUpdate = function (i) {

		this.profession_edit_id = i;
		this.is_profession_edit = true;
		this.professionList[i];
		this.professionForm.controls['profession_language'].setValue(this.professionList[i].profession_language);
		this.professionForm.controls['profession_name'].setValue(this.professionList[i].profession_name);
	}


	saveProfession = function () {

		var profession = this.professionForm.controls['profession'].value;
		var category_id = this.professionForm.controls['category_id'].value;

		if (profession == null || profession == '') {
			return false;
		}

		this.commonService.process();
		let requestObject = {
			profession: profession,
			profession_languages: this.professionList,
			category_id: category_id
		}

		if (this.edit_id) {

			requestObject['id'] = this.edit_id;

			this.authService.updateProfession(requestObject).subscribe(data => {
				if (data.success) {
					this.professionForm.reset();
					jQuery.growl.notice({ title: 'Success', message: data.message });
					this.router.navigate(['profession']);
				} else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				this.authService.cancelProcess();
			});

		} else {

			this.authService.addProfession(requestObject).subscribe(data => {
				if (data.success) {
					this.professionForm.reset();
					jQuery.growl.notice({ title: 'Success', message: data.message });
					this.router.navigate(['profession']);
				} else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				this.authService.cancelProcess();
			});

		}


	}

}


// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/profession-option/profession-option.component.ts